import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import {
  catchError,
  interval,
  lastValueFrom,
  retry
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { MonitorResponse, SyncMIResponse } from '../interfaces/magicInfoResponse';
import { MagicInfoService } from './magic-info.service';
import { handleError } from '../utils/generic-utils';

@Injectable({
  providedIn: 'root'
})
export class SyncMagicinfoService implements OnDestroy {

  endpoint: string = environment.performTVApi.url;
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    responseType: 'json',
  });
  retry = 0;

  constructor(private http: HttpClient, private magicInfoService: MagicInfoService) { }

  private _syncArr: SyncMIResponse[] = [];


  get syncRes() {
    return this._syncArr;
  }

  async monitorReq(requestId: string, group: SyncMIResponse) {
    await this.requestLog(requestId, group)

  }

  async requestLog(requestId: string, group: SyncMIResponse) {
    let api = `${this.endpoint}/request-log/${requestId}`;
    await lastValueFrom(
      this.http
        .get(api, { headers: this.headers, responseType: 'json' })
        .pipe(retry(this.retry), catchError(handleError))
    )
      .then((res: MonitorResponse) => {
        if (res.request_status == 'COMPLETED' || res.request_status == 'COMPLETED_WITH_WARNINGS') {
          group.intervalSubscription.unsubscribe();
          group.syncStatus = 'success';
          group.lastDateSync = res.created_on;
          this.magicInfoService.sendMISubs({
            channel: "SyncMagicinfoService - MagicInfoTableComponent",
            broadcastID: "SyncMagicinfoService",
            payload: {
              refresh: true
            }
          });
        }

        if (res.request_status == 'FAILED') {
          group.intervalSubscription.unsubscribe();
          group.syncStatus = 'fail';
          group.lastDateSync = undefined;
          group.message = res.response_payload.sys_message;

        }
      })
      .catch((error) => {
        console.log('monitor error', error);
        group.intervalSubscription.unsubscribe();
        group.syncStatus = 'fail';
        group.lastDateSync = error.message;
      });
  }

  async syncMI(payload: any) {
    let group = this._syncArr.find(g => g.device_group_id == payload.device_group_id)
    if (group) {
      group.syncStatus = 'progress';
    } else {
      this._syncArr.push({
        device_group_id: payload.device_group_id,
        syncStatus: 'progress',
        lastDateSync: ''
      })
    }
    let api = `${this.endpoint}/magic-info/import`;
    await lastValueFrom(
      this.http
        .post(api, payload, { headers: this.headers, responseType: 'json', observe: 'response' })
        .pipe(retry(this.retry), catchError(handleError))
    )
      .then((res: HttpResponse<any>) => {
        // console.log("response sync", res.status, body)
        if (res.status == 202) {
          // let resGrp = this._syncArr.find(g => g.device_group_id == payload.device_group_id)
          // resGrp.syncStatus = 'fail';
          // resGrp.lastDateSync = undefined;

          let resGrp = this._syncArr.find(g => g.device_group_id == payload.device_group_id)
          if (resGrp) {
            resGrp.source = interval(5000);
            resGrp.intervalSubscription = resGrp.source.subscribe(val => {
              if (val >= 6) {
                resGrp.intervalSubscription.unsubscribe();
                resGrp.source = interval(60000);
                resGrp.intervalSubscription = resGrp.source.subscribe(val => {
                  this.monitorReq(res.body.request_id, resGrp)
                })

              } else {
                this.monitorReq(res.body.request_id, resGrp)
              }
            });


          }
        } else {
          let resGrp = this._syncArr.find(g => g.device_group_id == payload.device_group_id)
          if (resGrp) {
            resGrp.syncStatus = 'success';
            resGrp.lastDateSync = res.body.last_sync;
            this.magicInfoService.sendMISubs({
              channel: "SyncMagicinfoService - MagicInfoTableComponent",
              broadcastID: "SyncMagicinfoService",
              payload: {
                refresh: true
              }
            });
          }
        }
      })
      .catch((error) => {
        console.log('sync error', error)
        let resGrp = this._syncArr.find(g => g.device_group_id == payload.device_group_id)
        if (resGrp) {
          resGrp.syncStatus = 'fail';
          resGrp.lastDateSync = undefined;
          resGrp.message = error.message;
        }
      });
  }

  ngOnDestroy(): void {
    this._syncArr.map(gr => {
      gr.intervalSubscription?.unsubscribe();
    })
  }

}
